import { CompanyDTO } from "@shaarp/common";

/** Returns the total number of contact entries (emails + phones) for a company. */
export const getContactCount = (company: CompanyDTO): number => {
  let count = 0;
  if (company.contact.emails?.length) count += company.contact.emails.length;
  if (company.contact.phones?.length) count += company.contact.phones.length;
  return count;
};

/** Returns the number of social network profiles and key links available for a company. */
export const getSocialNetworksCount = (company: CompanyDTO): number => {
  let count = 0;
  if (company.website) count++;
  if (company.links?.googleMaps) count++;
  if (company.business?.siren) count++;
  if (company.socialNetworks?.facebook?.url) count++;
  if (company.socialNetworks?.instagram?.url) count++;
  if (company.socialNetworks?.x?.url) count++;
  if (company.socialNetworks?.linkedin?.url) count++;
  if (company.socialNetworks?.tiktok?.url) count++;
  if (company.socialNetworks?.youtube?.url) count++;
  return count;
};

/**
 * Calculates a "data completeness" score for sorting companies
 * by how much data they have.
 */
export const getDataScore = (company: CompanyDTO): number => {
  let score = 0;
  score += getSocialNetworksCount(company);
  score += getContactCount(company);
  score += company.enrichmentLevel ?? 0;
  if (company.business?.siretFormatted) score += 2;
  if (company.estimatedRevenue?.range) score += 2;
  if (company.employeesCount?.estimatedRange) score += 2;
  if (company.activityTypeMain) score++;
  if (company.activityMain) score++;
  return score;
};
